export default __webpack_public_path__ + "static/media/Stalker's Grips of Waning Dusk.78f5cc52.jpg";